/**
 * SupplierSubscriptionService
 * Service for SupplierSubscription entity operations
 * Route: api/suppliersubscriptions
 * Controller: SupplierSubscriptionsController.cs
 */
import { CrudService } from '../base/CrudService';
export class SupplierSubscriptionService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SupplierSubscriptionService.DEFAULT_SERVICE_PATH,
            basePath: SupplierSubscriptionService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all subscriptions for a specific supplier
     */
    async getBySupplier(supplierId) {
        const response = await this.http.get(this.buildUrl(`by-supplier/${supplierId}`));
        return response.data ?? [];
    }
    /**
     * Get all subscription view models (enriched with supplier/status/type names)
     */
    async getAllViewModels() {
        const response = await this.http.get(this.buildUrl('viewmodels'));
        return response.data ?? [];
    }
}
SupplierSubscriptionService.DEFAULT_SERVICE_PATH = 'suppliers';
SupplierSubscriptionService.BASE_PATH = 'api/suppliersubscriptions';
//# sourceMappingURL=SupplierSubscriptionService.js.map